/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_CmsInputs */

const en_landing_chips_cms = /** @type {(inputs: Landing_Chips_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CMS`)
};

const zh_landing_chips_cms = /** @type {(inputs: Landing_Chips_CmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容管理`)
};

/**
* | output |
* | --- |
* | "CMS" |
*
* @param {Landing_Chips_CmsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_cms = /** @type {((inputs?: Landing_Chips_CmsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_CmsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_cms(inputs)
	return zh_landing_chips_cms(inputs)
});
export { landing_chips_cms as "landing.chips.cms" }